<template>
  <div class="swatch-container">
    <el-row class="tcf-row swatch-row">
      <el-col :span="24" class="card swatch-card">
        <div class="card-body">
          <div class="swatch-filter">
            <el-select v-model="brand" placeholder="品牌" size="small" :clearable="true" @change="brandChange">
              <el-option v-for="item in brandOptions" :key="item.brand_id" :label="item.brand_name" :value="item.brand_id" />
            </el-select>
          </div>
          <div class="swatch-filter">
            <el-select v-model="series" placeholder="系列" size="small" :clearable="true" @change="seriesChange">
              <el-option v-for="item in seriesOptions" :key="item.series_id" :label="item.series_name" :value="item.series_id" />
            </el-select>
          </div>
          <!-- <div class="swatch-filter">
            <el-select v-model="style" placeholder="风格" size="small" :clearable="true" @change="styleChange">
              <el-option v-for="item in styleOptions" :key="item.sid" :label="item.name" :value="item.sid" />
            </el-select>
          </div> -->
          <!-- <div class="swatch-filter">
            <el-select v-model="tone" placeholder="色调" size="small" :clearable="true" @change="toneChange">
              <el-option
                v-for="item in toneOptions"
                :key="item.tid"
                :label="item.name"
                :value="item.tid" >
                <span style="float: left">{{ item.name }}</span>
                <div class="swatch-tone" :style="'background-image: url('+item.imgurl+')'"></div>
              </el-option>
            </el-select>
          </div> -->
          <div class="search-mode">
            <input type="text" class="search-input" placeholder="关键字搜索" v-model="search" @keyup.enter="searchSwatch" />
            <el-button class="search-btn" icon="el-icon-search" @click="searchSwatch"/>
          </div>
          <div class="swatch-button">
            <el-button size="small" icon="el-icon-plus" type="primary" @click="editRow(null)">新增色板</el-button>
          </div>
          <div class="card-content" v-loading="loading">
            <el-table
              :data="swatchData"
              stripe
              style="width: 100%">
              <el-table-column
                label="色板"
                width="100">
                <template slot-scope="scope">
                  <el-image
                    :src="scope.row.img_url"
                    fit="cover"
                    style="width: 40px;height: 60px;"
                    :preview-src-list="[scope.row.img_url]">
                  </el-image>
                </template>
              </el-table-column>
              <el-table-column
                prop="code"
                label="编号"
                width="140"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="name"
                label="名称"
                width="140"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="brandname"
                label="品牌"
                width="110"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                prop="seriesname"
                label="系列"
                width="110"
                show-overflow-tooltip>
              </el-table-column>
              <!-- <el-table-column
                prop="stylename"
                label="风格"
                width="110"
                show-overflow-tooltip>
              </el-table-column> -->
              <!-- <el-table-column
                prop="tonename"
                label="色调"
                width="110"
                show-overflow-tooltip>
              </el-table-column> -->
              <el-table-column
                prop="remarks"
                label="备注"
                min-width="300"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="操作"
                width="330"
                align="center"
                fixed="right"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-button icon="el-icon-view" size="mini" @click="seeOrders(scope.row)">查看关联订单</el-button>
                  <el-button icon="el-icon-edit" size="mini" @click="editRow(scope.row)">修改</el-button>
                  <el-button icon="el-icon-delete" size="mini" @click="deleteRow(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total>0 || true"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-dialog
      :title="dialogtitle"
      :visible.sync="dialogVisible"
      width="40%"
      top="30px"
      :before-close="handleClose"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="编号" prop="code">
          <el-input v-model="form.code"></el-input>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brandId">
          <el-select clearable v-model="form.brandId">
            <el-option
              v-for="item in brandOptions"
              :label="item.brand_name"
              :value="item.brand_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="系列" prop="seriesId">
          <el-select clearable v-model="form.seriesId">
            <el-option
              v-for="item in seriesOptions"
              :label="item.series_name"
              :value="item.series_id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="风格" prop="styleId">
          <el-select clearable v-model="form.styleId">
            <el-option
              v-for="item in styleOptions"
              :label="item.name"
              :value="item.sid">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="色调" prop="toneId">
          <el-select clearable v-model="form.toneId">
            <el-option
              v-for="item in toneOptions"
              :label="item.name"
              :value="item.tid">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="色板" prop="image">
          <SingleImg :key="imgkey" v-model="form.image" :oldurl="form.oldImg_url" :size="[100,150]" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remarks" maxlength="600" :rows="4" placeholder="请输入备注信息" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="editloading" @click="submitForm('form')">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="viewTitle + ' 关联订单列表'" :visible.sync="orderVisible" width="80%" top="10vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding:10px 20px">
        <el-table
          :data="orderList"
          v-loading="orderLoading"
          size="small"
          :row-style="{cursor: 'pointer'}"
          @row-click="openDetails"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="442">
         <el-table-column
           label="订单号"
           width="120"
           fixed
           show-overflow-tooltip>
           <template slot-scope="scope">
             <span>{{scope.row.ordernum}}</span>
           </template>
         </el-table-column>
         <el-table-column
           label="生产单号"
           width="120"
           fixed
           align="center"
           show-overflow-tooltip>
           <template slot-scope="scope">
             <span style="font-weight: 500;color:#409EFF" v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">{{scope.row.produnum}}</span>
             <span style="font-weight: 500;color:#999999" v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined">N/A</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="delname"
           label="经销商"
           align="center"
           width="120"
           show-overflow-tooltip>
         </el-table-column>
         <el-table-column
           label="订单类型"
           width="110"
           align="center"
           show-overflow-tooltip>
           <template slot-scope="scope">
             <span v-if="scope.row.type===0">正单</span>
             <span v-if="scope.row.type===1">客改单</span>
             <span v-if="scope.row.type===2">增补单</span>
             <span v-if="scope.row.type===3">色板单</span>
             <span v-if="scope.row.type===4">售后单</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="time"
           label="上次操作时间"
           width="170"
           align="center"
           show-overflow-tooltip>
         </el-table-column>
         <el-table-column
           label="拆单人员"
           align="center"
           width="120">
           <template slot-scope="scope">
             <span v-if="scope.row.splitName!==''&&scope.row.splitName!==null">{{ scope.row.splitName }}</span>
             <span v-if="scope.row.splitName===''||scope.row.splitName===null" style="color: #99a9bf;">N/A</span>
           </template>
         </el-table-column>
         <el-table-column
           prop="address"
           label="详细地址"
           min-width="200"
           show-overflow-tooltip>
         </el-table-column>
         <el-table-column
           label="当前状态"
           fixed="right"
           width="100"
           align="center"
           show-overflow-tooltip>
           <template slot-scope="scope">
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===2" type="danger">售后驳回</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===3" type="danger">评估驳回</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===4" type="danger">确认驳回</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===5" type="danger">报价驳回</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===6" type="danger">预付驳回</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===7" type="danger">工厂拒接</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===8" type="danger">审单驳回</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2&&scope.row.dismark===0" type="warning">待接单</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===3" class="tcf-tag-1">售后处理</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===4" class="tcf-tag-5">技术评估</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===5" class="tcf-tag-4">拆单分配</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===6&&scope.row.dismark===0" class="tcf-tag-2">待拆单</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===7&&scope.row.dismark===0" class="tcf-tag-6">订单确认</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===8&&scope.row.dismark===0" class="tcf-tag-3">待报价</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===9&&scope.row.dismark===0" class="tcf-tag-9">预付款</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===10&&scope.row.dismark===0" class="tcf-tag-7">工厂分派</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===11" class="tcf-tag-8">工厂接单</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===12" class="tcf-tag-10">订单排产</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===13" class="tcf-tag-11">订单生产</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===88" class="tcf-tag-1">待审单</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===99">已取消</el-tag>
             <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===100">已完成</el-tag>
           </template>
         </el-table-column>
        </el-table>

        <el-pagination v-if="orderPage.total>0" style="margin-top:10px;" background @size-change="handleSizeChangeOrder"
          @current-change="handleCurrentChangeOrder" :current-page="orderPage.currentPage" :page-sizes="[10, 20, 50]"
          :page-size="orderPage.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="orderPage.total">
        </el-pagination>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getStyleList } from '@/api/pub'
import { getUser } from '@/utils/auth'
import { getBrandSeriesList } from '@/api/pub'
import { getColorList, getSeriesList } from '@/api/pub'
import { getColorBoardList, getSwatch, updateOrAddSwatch, deleteSwatch } from '@/api/about/swatch'
import { getALLOrderList } from '@/api/erp'
import SingleImg from '@/components/upload/SingleImg'
import sidebar from '@/layout/components/Sidebar'

export default {
  name: 'swatch_list',
  computed: {
    user: getUser
  },
  components: {
    SingleImg
  },
  data() {
    return {
      loading: false,
      editloading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      brand: '',
      series: '',
      style: '',
      tone: '',
      search: '',
      brandOptions: [],
      seriesOptions: [],
      styleOptions: [],
      toneOptions: [],
      swatchData: [],
      imgViewUrl: [],
      dialogVisible: false,
      imgkey: '',
      // 编辑色板弹窗
      form: {
        code: '',
        name: '',
        brandId: '',
        seriesId: '',
        styleId: '',
        toneId: '',
        image: null,
        oldImg_url: '',
        remarks: '',
        board_id: ''
      },
      rules: {
        code: [
          { required: true, message: '请输入编码', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        brandId: [
          { required: true, message: '请选择品牌', trigger: 'change' }
        ],
        seriesId: [
          { required: true, message: '请选择系列', trigger: 'change' }
        ],
        styleId: [
          { required: true, message: '请选择风格', trigger: 'change' }
        ],
        toneId: [
          { required: true, message: '请选择色调', trigger: 'change' }
        ],
        image: [
          { required: true, message: '请上传图片', trigger: 'change' }
        ]
      },
      // 色板标题
      dialogtitle: '',

      viewTitle: '',
      viewSid: '',
      orderVisible: false,
      orderLoading: false,
      orderList: [],
      orderPage: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    }
  },
  created() {
    this.getData()
    this.getSelectData()
  },
  methods: {
    // 获取选择框的数据
    getSelectData() {
      // getStyleList().then(response => {
      //   this.styleOptions = response.data
      // })
      // getColorList().then(response => {
      //   this.toneOptions = response.data
      // })
      getBrandSeriesList().then(response => {
        this.brandOptions = response.data
      })
      getSeriesList().then(response => {
        this.seriesOptions = response.data
      })
    },
    // 获取色板的数据
    getData() {
      this.loading = true
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        content: this.search,
        seriesid: this.series,
        brandid: this.brand,
        styleid: this.style,
        colorid: this.tone
      }
      getColorBoardList(data).then(response => {
        this.loading = false
        this.swatchData = response.data
        this.total = response.total
        for (const d of response.data) {
          this.imgViewUrl.push(d.img_url)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页更改更新数据
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    // 弹窗信息
    seeOrders(row) {
      this.viewSid = row.board_id
      this.viewTitle = row.code + '/' + row.name
      this.orderVisible = true
      this.getOrdersData()
    },
    // 分页更改更新数据
    handleSizeChangeOrder(val) {
      this.orderPage.pageSize = val
      this.getOrdersData()
    },
    handleCurrentChangeOrder(val) {
      this.orderPage.currentPage = val
      this.getOrdersData()
    },
    openDetails(row) {
      if (row.orderid.length > 36) {
        this.$router.push({
          path: '/work/order/' + row.orderid.substring(0, 36),
          query: {
            data: row.orderid.substring(37)
          }
        })
      } else {
        this.$router.push({ path: '/work/order/' + row.orderid.substring(0, 36) })
      }
      this.orderVisible = false
    },
    getOrdersData() {
      this.orderLoading = true
      const data = {
        sid: this.viewSid,
        role: 1,
        page: this.orderPage.currentPage,
        limit: this.orderPage.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid
      }
      this.orderList = []
      this.orderPage.total = 0
      getALLOrderList(data).then(response => {
        this.orderList = response.data || []
        this.orderPage.total = response.total || 0
        this.orderLoading = false
      }).catch(() => {
        this.orderLoading = false
      })
    },
    // 弹窗信息
    editRow(row) {
      this.imgkey = new Date().getTime().toString()
      this.dialogVisible = true
      if (row != null) {
        this.dialogtitle = '修改色板信息'
        this.form.board_id = row.board_id
        this.form.code = row.code
        this.form.name = row.name
        this.form.brandId = row.brandid
        this.form.seriesId = row.seriesid
        this.form.styleId = row.styleid
        this.form.toneId = row.toneid
        this.form.remarks = row.remarks === '暂无备注信息！' ? '' : row.remarks
        this.form.image = { imgid: row.imgid, imgurl: row.img_url }
        this.form.oldImg_url = row.img_url
      } else {
        this.dialogtitle = '新增色板信息'
        this.form.board_id = null
        this.form.code = ''
        this.form.name = ''
        this.form.brandId = ''
        this.form.seriesId = ''
        this.form.styleId = ''
        this.form.toneId = ''
        this.form.remarks = ''
        this.form.image = null
        this.form.oldImg_url = ''
      }
    },
    deleteRow(row) {
      this.$confirm('您确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteSwatch({ sid: row.board_id }).then(response => {
          this.$message({
            type: 'success',
            message: response.msg
          })
          this.getData()
        })
      }).catch(() => {})
    },
    // 提交表单
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            let data = {}
            if (this.form.board_id == null) {
              data = {
                bid: this.form.brandId,
                series: this.form.seriesId,
                style: this.form.styleId,
                tone: this.form.toneId,
                name: this.form.name,
                num: this.form.code,
                imgid: this.form.image.imgid,
                remarks: this.form.remarks
              }
            } else {
              data = {
                sid: this.form.board_id,
                bid: this.form.brandId,
                series: this.form.seriesId,
                style: this.form.styleId,
                tone: this.form.toneId,
                name: this.form.name,
                num: this.form.code,
                imgid: this.form.image.imgid,
                remarks: this.form.remarks
              }
            }

            updateOrAddSwatch(data).then(response => {
              this.editloading = false
              this.$message({
                type: 'success',
                message: '提交成功'
              })
              this.getData()
              this.dialogVisible = false
            }).catch(() => {
              this.dialogVisible = false
            })
          }
          this.editloading = false
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 搜索功能
    brandChange(val) {
      this.currentPage = 0
      this.brand = val
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    },
    seriesChange(val) {
      this.series = val
      this.currentPage = 0
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    },
    styleChange(val) {
      this.style = val
      this.currentPage = 0
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    },
    toneChange(val) {
      this.tone = val
      this.currentPage = 0
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    },
    searchSwatch() {
      this.currentPage = 0
      this.swatchData = []
      this.imgViewUrl = []
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .swatch-container{
    .swatch-row{
      padding:20px 10px;
      .swatch-card{
        padding: 0 10px;
        .card-body{
          .card-content{
            .group-filter{
              width: 100%;
              padding: 0 30px 0 0 ;
              margin: 0 ;
              position: relative;
              li{
                width: 100%;
                list-style: none;
                position: relative;
                padding-left: 20px;
                padding-top: 15px;
                padding-bottom: 15px;
                cursor: pointer;
                border-radius: 2px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                &.active{
                  background: #f5f7fa;
                  color:#409EFF;
                }
                &:hover{
                  color:#409EFF;
                }
              }
            }
            .client-sex{
              width: 16px!important;
              height: 16px!important;
              vertical-align: -4px!important;
            }
            .el-table::before{
              height: 0!important;
            }
            .el-pagination{
              margin-top: 20px;
            }
          }
          .swatch-filter{
            position: relative;
            float: left;
            margin-right: 20px;
            padding-bottom: 20px;
            &:last-child{
              margin-right: 0;
            }
          }
          .search-mode{
            float: left;
            width: 200px;
            position: relative;
            padding-right: 20px;
            padding-bottom: 20px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 32px;
              line-height: 32px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 20px;
              height: 32px;
              width: 40px;
              line-height: 32px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
          .swatch-button{
            position: relative;
            float: right;
            padding-bottom: 20px;
          }
        }
      }
    }
  }
</style>
